import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import QuadChart from '../common/Charts/QuadChart';
import DroppableTableRow from './DroppableTableRow';
import closeX from '../../images/clear-field-icon_white.png';
import { MODULE_INCREMENTAL_REACH } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

class IncrementalReach extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      incReachIndexes: [],
      incData: [],
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
    };
  }

  componentDidMount() {
    this.props.handletitle('Incremental Reach Across Platforms');
    this.props.handleExportParams(
      undefined,
      undefined,
      undefined,
      undefined,
      this.state.incReachIndexes
    );
    this.props.trackerFn({ subModule: MODULE_INCREMENTAL_REACH });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
    if (nextProps.data !== this.state.data) {
      this.setState({
        incData: nextProps.data.incrementalReach,
      });
    }
  }

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  handleCheckboxChange = name => {
    const clickedElement = this.state.data['7 Day Reach'].filter(
      ({ label }) => name === label
    );
    const rowIndex = clickedElement[0].value.rowIndex;
    const elementIndex = this.state.incReachIndexes.indexOf(rowIndex);
    if (elementIndex >= 0) {
      this.state.incReachIndexes.splice(elementIndex, 1);
    } else {
      this.setState(
        {
          incReachIndexes: [...this.state.incReachIndexes, rowIndex],
        },
        () =>
          this.props.handleExportParams(
            undefined,
            undefined,
            undefined,
            undefined,
            this.state.incReachIndexes
          )
      );
    }
    this.props.runReport(null, null, null, this.state.incReachIndexes);
  };

  handleDrop = (dragIndex, dropIndex) => {
    if (dropIndex === 0) {
      this.state.incReachIndexes.unshift(this.state.incReachIndexes[dragIndex]);
      this.state.incReachIndexes.splice(dragIndex + 1, 1);
    } else if (dropIndex === this.state.incData.length - 1) {
      this.state.incReachIndexes.push(this.state.incReachIndexes[dragIndex]);
      this.state.incReachIndexes.splice(dragIndex, 1);
    } else {
      const elements = this.state.incReachIndexes.filter(
        (value, index) => index !== dragIndex
      );
      const element = this.state.incReachIndexes[dragIndex];
      if (dragIndex > dropIndex) {
        elements.splice(dropIndex, 0, element);
      } else if (dragIndex < dropIndex) {
        elements.splice(dropIndex + 1, 0, element);
      }
      this.setState({
        incReachIndexes: elements,
      });
      // const elements = this.state.incReachIndexes.filter((value, index) => index !== dragIndex);
      // const element = this.state.incReachIndexes[dragIndex];
      // this.state.incReachIndexes.splice(dragIndex, 0, this.state.incReachIndexes[dragIndex]);
      // const index = this.state.incReachIndexes.indexOf(element);
      // this.state.incReachIndexes.splice(index, 1);
    }
    this.props.runReport(null, null, null, this.state.incReachIndexes);
  };

  renderGeneralTable = () => (
    <div className="incremental-reach-table base-target-table">
      <div className="table-head">
        <div className="table-th th-height">
          <div className="table-td" title="Channels">
            Channels
          </div>
          <div className="table-td" title="Reach">
            Reach
          </div>
          <div className="table-td" title="Incr. Reach">
            Incr. Reach
          </div>
          <div className="table-td" title="Total Reach">
            Total Reach
          </div>
        </div>
      </div>
      <div className="table-tbody">
        {this.state.incData
          ? this.state.incData.map(({ label, value }, index) => (
              <DroppableTableRow
                key={uuid()}
                itemIndex={index}
                label={label}
                value={value}
                handleDrop={this.handleDrop}
              />
            ))
          : ''}
      </div>
    </div>
  );

  renderData = () =>
    this.state.data['7 Day Reach'].map((row, index) => ({
      x: Number(
        this.state.data['Time Spent'][index].value.hours.replace(/[:]/g, '.')
      ),
      y: Number(row.value.pct.replace(/[*,%, ]/g, '')),
      z: 1,
      name: row.label,
      rowIndex: this.state.data['Time Spent'][index].value.rowIndex,
    }));

  render() {
    const that = this;
    return (
      <div
        className="quick-report-graph-wrapper incremental-reach-wrapper"
        style={{ padding: '15px 15px 40px 15px' }}
      >
        <div>
          <div className="row expanded">
            <div className="columns small-12 medium-7 large-8">
              <QuadChart
                chartColor={chartColor}
                data={this.renderData()}
                xAxisName='Time Spent in Hours (Average Week)'
                yAxisName='Reach (% of target)'
                dataLabelFormatter={function format() {
                  return `<div class="incr-reach-custom-legend"><input type="checkbox" />${
                    this.point.name
                  }</div>`;
                }}
                clickEvent={() => {
                  that.handleCheckboxChange(event.srcElement.textContent);
                }}
              />
            </div>
            <div className="columns medium-5 large-4">
              <div className="incr-reach-table-clear">
                <button type="submit" className="clear-btn">
                  <img src={closeX} alt="clear" />
                </button>
              </div>
              {this.renderGeneralTable()}
            </div>
          </div>
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

IncrementalReach.propTypes = {
  data: PropTypes.shape({}),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  runReport: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};

export default IncrementalReach;
